module.exports = __webpack_public_path__ + "img/icon-05.569ce0db.svg";